module.exports = __webpack_public_path__ + "media/src/components/SubscriptionPlans/img/chip-317620cfb9ef57dbacdcfeb8b7ccb85c.svg";